import { type FC, useEffect } from 'react';

import { NODE_NAME } from '@utils/eventBus/constants';

type EventBusProps = React.PropsWithChildren;

export const EventBus: FC<EventBusProps> = props => {
  const { children } = props;

  useEffect(() => {
    const element = document.createComment(NODE_NAME);

    document.body.appendChild(element);
  }, []);

  return <>{children}</>;
};
